require('./pricing-lead-form.scss');
var validateLeadForm = require('src/interlock/no-ui/validation/lead');
var thankyouPage = require('src/interlock/lead/thank-you/inventory/pricing/price-promise-multi-select');
var tracking = require('./lead-form-tracking');
var deferredLoader = require('src/interlock/no-ui/defer/loader');
var queryString = require('query-string');
var utils = require('./utils');
var leadformDrawer ='.lead-form-pricing-drawer.modal-drawer';
var thankyouDrawer ='.lead-form-price-promise-thank-you.modal-drawer';
var pricingLeadFormHelper = require('./pricing-lead-form-helper');
var forms = {};
var timestamp = 0;

var leadTypeUrls = {
    '1':'/api/lead/v1/dealerlocator/',
    '2':'/api/lead/v1/new/',
    '4':'/api/lead/v1/newpricepromise/'
};

function makeParamsStr(params) {
    return queryString.stringify(params, {
        strict: true,
        encode: true
    });
}

function createLeadForm() {
    timestamp = Date.now();
    var leadFormEl = $('.lead-form-pricing .lead-form:visible');
    var options = $('.lead-form-pricing').data('options');
    return validateLeadForm.createLeadForm((leadFormEl), options);
}

function clearSameForm(name) {
    var theForm = forms[name];
    if (theForm) {
        theForm.clear();
        theForm = null;
    }
}

function onSubmit(e, params) {

    var theForm = e.target;
    var selectDealerErrorEl = $(theForm).find('.select-dealer-error');
    var selData = pricingLeadFormHelper.getSelectedData();
    selectDealerErrorEl.toggleClass('hidden-xs-up', selData.length > 0);
    if(!selData.length) {
        return;
    }
    var formData = utils.getFormData(theForm);
    var totalPossibleLeads = pricingLeadFormHelper.getInventoryCount();
    var thankYouObj = utils.fillThankyouData(theForm, selData);
    var idea = {'2':'NCI','4':'PP'};
    var typeStr = '';
    var blended = 'n';

    $.ajax({
        type: 'POST',
        url: utils.getThankYouPageUrl(),
        contentType: 'application/json',
        data: JSON.stringify(thankYouObj),
        dataType: 'json'
    }).then(function(result){
        $('#edm-entry-new-pp-multi-select-thank-you').html(result.htmls[Object.keys(result.htmls)[0]]);
    }).then(function(){
        thankyouPage.loadThankyouPage(params);
    });

    var promiseArr = selData.map(function (vehData, index) {
        var leadOpportunityKey = utils.fillLeadOpportunityKey(vehData, index, totalPossibleLeads);
        var data = utils.fillData(formData, vehData, params.zipcode, leadOpportunityKey, timestamp);

        if(typeStr.length > 0 && idea[vehData.leadType]){
            typeStr += (','+idea[vehData.leadType]);
            blended='y';
        } else if(typeStr.length === 0 && idea[vehData.leadType]){
            typeStr = idea[vehData.leadType];
        }
        idea[vehData.leadType] = '';
        return $.ajax({
            type: 'POST',
            url: leadTypeUrls[vehData.leadType],
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json'
        }).promise();
    });

    Promise.all(promiseArr.map(utils.reflect)).then(function(results) {
        var success = results.filter(function (x) {
            return x.status === true;
        });

        // if any lead has successfully submitted
        if (success.length) {
            tracking.fireSuccessfulSubmit(typeStr, blended, selData.length);

            utils.switchToDrawer(leadformDrawer, thankyouDrawer);
        }
    });
}

module.exports = {
    createLeadForm: createLeadForm,
    loadLeadForm: function (payLoad, params) {
        tracking.fireOpenWidgetTracking();
        var paramsStr = makeParamsStr(params);
        clearSameForm(paramsStr);
        $('#edm-entry-pricing-lead-form').html('');
        return deferredLoader.loadEntryWithPost('pricing-lead-form',
                '/groundwork/lead/form/pricing/index.entry?'+paramsStr+'&entry-id=pricing-lead-form', payLoad).
            done(function () {
                tracking.readyListTracking();
                forms[paramsStr] = createLeadForm();
                utils.readyCollapse();
                pricingLeadFormHelper.addCheckboxHandler(forms[paramsStr].$form);
                forms[paramsStr].addOnSubmitCallback(function (e) {
                    onSubmit(e, params);
                });
                pricingLeadFormHelper.calcSavings();
            });
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/creative/pricing-lead-form/pricing-lead-form.js
// module id = 153
// module chunks = 0 1 16 19